import $ from 'jquery';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

$(() => {
  document.fonts.ready.then(() => {
    const $number = $('.error-number');
    const $title = $('.error-title');
    const $description = $('.error-description');

    const $elements = $number.add($title).add($description).filter((_index: number, el: HTMLElement) => $(el).length > 0);

    if (!$elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $elements.each((_index: number, el: HTMLElement) => {
        gsap.set(el, { opacity: 1, y: 0, filter: 'none' });
      });
      return;
    }

    const tl = gsap.timeline();

    $elements.each((i: number, el: HTMLElement) => {
      const $el = $(el);
      const split = $el.hasClass('error-number')
        ? null
        : new SplitText(el, { type: 'words' });

      tl.from(
        el,
        {
          y: 24,
          opacity: 0,
          duration: 2,
          ease: 'power2.out',
        },
        i * 0.3
      );

      if (split) {
        const isDescription = $el.hasClass('error-description');

        tl.from(
          split.words,
          {
            opacity: 0,
            filter: 'blur(10px)',
            duration: isDescription ? 0.5 : 0.8,
            ease: 'power2.out',
            stagger: isDescription ? 0.08 : 0.15,
          },
          i * 0.3 + 0.15
        );
      }
    });
  });
});
